import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskPriorityComponent } from './task-priority.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TaskPriorityComponent],
  exports: [TaskPriorityComponent]
})
export class TaskPriorityLookupModule { }
